import React from 'react'
import { useFindMenu, useTealium } from '@next-nx/hooks'
import { Swiper, SwiperSlide } from 'swiper/react'
import { WContainer, Chip } from '@next-nx/shared-ui/atoms'
import { getTimestamp } from '@next-nx/utils'
import styles from './Prefooter.module.sass'

interface Props {
  className?: string
}

const Prefooter = (props: Props) => {
  const { className = '' } = props

  const menu = useFindMenu('prefooter')
  const { linkDataLayer } = useTealium()

  const handleTracking = (action_type?: string, interazione?: string) => {
    const action_timestamp = getTimestamp()
    let dlObj = {}

    switch (interazione) {
      case 'help':
        dlObj = {
          virtual: 'action',
          action_name: 'navigazione',
          action_tech: 'click',
          action_type: action_type?.replace(/\.|\/|\s+/g, '_').toLowerCase(),
          action_timestamp,
          action_effect: 'interazione_componente_help',
        }
        break
      default:
        dlObj = {
          virtual: 'action',
          action_name: 'contattaci',
          action_tech: 'click',
          action_type: 'accedi',
          action_timestamp,
          action_effect: 'accesso_pagina_contatti',
        }
        break
    }
    linkDataLayer(dlObj)
  }

  return menu ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={styles.content}>
          {!!menu.name && <p className={styles.title}>{menu.name}</p>}
          <div className={styles.list}>
            <Swiper spaceBetween={16} slidesPerView="auto" watchOverflow>
              {menu?.children?.edges
                ?.map((item) => item.node)
                .filter((item) => !!item.url && !!item.name)
                .map((item) => (
                  <SwiperSlide key={item.pk}>
                    <Chip
                      variant="lg"
                      url={item.url}
                      label={item.name || ''}
                      handleTracking={() => {
                        if (item?.url?.includes('contattaci')) {
                          handleTracking()
                        }
                        handleTracking(item.name || '', 'help')
                      }}
                    />
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default Prefooter
